
<div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:h-full">

  <div class="tw:w-full tw:p-0 tw:m-0 tw:px-2" #calendarContainer>

    <!--CURRENT SESSION MONTHS-->
    <div class="tw:flex months-container" [ngClass]="{'tw:flex-nowrap': !wrapOnMonth, 'tw:flex-wrap': wrapOnMonth}">
      @for (currentMonths of sessionCalendarCurrent; track currentMonths) {
        @if (monthHasVisibleSession(currentMonths)) {
        <div class="tw:text-center month-main-container" [ngClass]="{'month-main-container--no-border': wrapOnMonth}"  #scrollMe>
          <div class="tw:w-full tw:flex tw:justify-center tw:items-center">
            <label class="month-main-label">{{currentMonths.title}}</label>
          </div>
          <div class="tw:w-full tw:flex tw:justify-center tw:items-center sub-label-container">
            <label class="month-sub-label">{{currentMonths.subTitle}}</label>
          </div>
          <div class="month-list-container tw:mt-2" [ngClass]="{'month-list-container--wrap' : wrapWeeks}">
            @for (currentWeeks of currentMonths.sessionWeeks; track currentWeeks) {
              @if (weekHasVisibleSession(currentWeeks)) {
              <div class="tw:text-center week-main-container">
                <div class="tw:w-full tw:flex tw:justify-center tw:items-center">
                  <label class="week-main-label" [ngClass]="{'week-label-underline': currentWeeks.highlight}" >{{currentWeeks.title}}</label>
                </div>
                <div class="tw:w-full tw:flex tw:justify-center tw:items-center sub-label-container">
                  <label class="week-sub-label">{{currentWeeks.subTitle}}</label>
                </div>
                <div class="week-list-container tw:mt-2">
                  @for (currentSession of currentWeeks.sessions; track currentSession) {
                    @if (isStatusVisible(currentSession.status)) {
                    <div class="session-block-item-container"
                      [ngClass]="{'session-block-disabled': !showNavButtons && currentSession.disabled && !currentSession.selected, 'session-block-item': showNavButtons || !currentSession.disabled && !currentSession.selected, 'session-block-selected': currentSession.selected, 'session-block-outside-range': currentSession.outsideDateRange  }">
                      <div class="tw:mb-2 tw:text-center">
                        <app-session-status-pill [status]="currentSession.status"></app-session-status-pill>
                      </div>
                      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                        [ngClass]="{'cursor-not-allowed': !showNavButtons &&currentSession.disabled }">
                        <div class="tw:flex-1 tw:p-0 tw:m-0"
                          [ngClass]="{'cursor-not-allowed': !showNavButtons && currentSession.disabled }">
                          <label class="session-block-label"
                            [ngClass]="{'cursor-not-allowed': !showNavButtons && currentSession.disabled }">
                            {{currentSession.startDate | date: 'dd MMM yyyy'}}
                          </label>
                        </div>
                      </div>
                      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
                        <div class="tw:flex-1 tw:p-0 tw:m-0"
                          [ngClass]="{'cursor-not-allowed': !showNavButtons && currentSession.disabled }">
                          <label class="session-block-label"
                            [ngClass]="{'cursor-not-allowed': !showNavButtons && currentSession.disabled }">
                            {{currentSession.startTime.length > 5 ? currentSession.startTime.slice(0, -3) : currentSession.startTime}} -
                            {{currentSession.endTime.length > 5 ? currentSession.endTime.slice(0, -3) : currentSession.endTime}}
                          </label>
                        </div>
                      </div>
                      @if (showNavButtons) {
                        <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
                          <div class="tw:flex-1 tw:px-[15px]">
                            <button class="btn btn-outline-primary font-12" (click)="selectSession(currentSession)">View session</button>
                          </div>
                        </div>
                      }
                    </div>
                    }
                  }
                </div>
              </div>
              }
            }
          </div>
        </div>
        }
      }
      <!--CURRENT SESSION MONTHS-->

      @if (hideFutureSessions && sessionCalendarFuture.length > 0) {
        <div class="next-icon-main-container tw:flex tw:grow tw:justify-center tw:items-center">
          <div class="next-chevron-icon-container tw:flex tw:items-center cursor-pointer" (click)="hideFutureSessions = false">
            <div class="next-chevron-icon cursor-pointer">
            </div>
          </div>
        </div>
      }

      <!--FUTURE SESSION MONTHS-->
      @for (futureMonths of sessionCalendarFuture; track futureMonths) {
        @if (monthHasVisibleSession(futureMonths)) {
        <div class="tw:text-center month-main-container"
          [ngClass]="{'tw:hidden': hideFutureSessions}">
          <div class="tw:w-full tw:flex tw:justify-center tw:items-center">
            <label class="month-main-label">{{futureMonths.title}}</label>
          </div>
          <div class="tw:w-full tw:flex tw:justify-center tw:items-center sub-label-container">
            <label class="month-sub-label">{{futureMonths.subTitle}}</label>
          </div>
          <div class="month-list-container tw:mt-2" [ngClass]="{'month-list-container--wrap' : wrapWeeks}">
            @for (futureWeeks of futureMonths.sessionWeeks; track futureWeeks) {
              @if (weekHasVisibleSession(futureWeeks)) {
              <div class="tw:text-center week-main-container">
                <div class="tw:w-full tw:flex tw:justify-center tw:items-center">
                  <label class="week-main-label">{{futureWeeks.title}}</label>
                </div>
                <div class="tw:w-full tw:flex tw:justify-center tw:items-center sub-label-container">
                  <label class="week-sub-label">{{futureWeeks.subTitle}}</label>
                </div>
                <div class="week-list-container tw:mt-2">
                  @for (futureSession of futureWeeks.sessions; track futureSession) {
                    @if (isStatusVisible(futureSession.status)) {
                    <div class="session-block-item-container"
                      [ngClass]="{'session-block-disabled': !showNavButtons && futureSession.disabled && !futureSession.selected, 'session-block-item': showNavButtons || !futureSession.disabled && !futureSession.selected, 'session-block-selected': futureSession.selected, 'session-block-outside-range': futureSession.outsideDateRange  }">
                      <div class="tw:mb-2 tw:text-center">
                        <app-session-status-pill [status]="futureSession.status"></app-session-status-pill>
                      </div>
                      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                        [ngClass]="{'cursor-not-allowed': !showNavButtons &&futureSession.disabled }">
                        <div class="tw:flex-1 tw:p-0 tw:m-0"
                          [ngClass]="{'cursor-not-allowed': !showNavButtons && futureSession.disabled }">
                          <label class="session-block-label"
                            [ngClass]="{'cursor-not-allowed': !showNavButtons && futureSession.disabled }">
                            {{futureSession.startDate | date: 'dd MMM yyyy'}}
                          </label>
                        </div>
                      </div>
                      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                        [ngClass]="{'cursor-not-allowed': !showNavButtons &&futureSession.disabled }">
                        <div class="tw:flex-1 tw:p-0 tw:m-0"
                          [ngClass]="{'cursor-not-allowed': !showNavButtons && futureSession.disabled }">
                          <label class="session-block-label"
                            [ngClass]="{'cursor-not-allowed': futureSession.disabled }">
                            {{futureSession.startTime.length > 5 ? futureSession.startTime.slice(0, -3) : futureSession.startTime}} -
                            {{futureSession.endTime.length > 5 ? futureSession.endTime.slice(0, -3) : futureSession.endTime}}
                          </label>
                        </div>
                      </div>
                      @if (showNavButtons) {
                        <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
                          <div class="tw:flex-1 tw:px-[15px]">
                            <button class="btn btn-outline-primary font-12" (click)="selectSession(futureSession)">View session</button>
                          </div>
                        </div>
                      }
                    </div>
                    }
                  }
                </div>
              </div>
              }
            }
          </div>
        </div>
        }
      }
      <!--FUTURE SESSION MONTHS-->

    </div>
  </div>

</div>
